
import { defineComponent, reactive, watch, ref, inject } from "vue";

export default defineComponent({
  name: "investment-ticket-size",
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
    touchedAdvancedAssurance: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const touched = ref<boolean>(false);
    const isAnyAdvancedAssuranceNotSelected = ref<boolean>(false);
    watch(
      () => props.touchedAdvancedAssurance,
      (value) => {
        touched.value = value;
        shouldShowError();
      }
    );
    const shouldShowError = () => {
      if (
        !advancedAssuranceOptions?.[0]?.value &&
        !advancedAssuranceOptions?.[1]?.value &&
        !advancedAssuranceOptions?.[2]?.value &&
        !advancedAssuranceOptions?.[3]?.value
      )
        isAnyAdvancedAssuranceNotSelected.value = false;
      else isAnyAdvancedAssuranceNotSelected.value = true;
      emit(
        "isSelected",
        isAnyAdvancedAssuranceNotSelected.value ? true : false
      );
    };
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    const stageOfEvolution = reactive([
      { name: "stageOfEvolutionPreSeed", value: false },
      { name: "stageOfEvolutionSeed", value: false },
      { name: "stageOfEvolutionPreSeriesA", value: false },
      { name: "stageOfEvolutionSeriesA", value: false },
    ]);
    const minimumTraction = reactive([
      { name: "minimumTractionPreMvp", value: false },
      { name: "minimumTractionPostMvp", value: false },
      { name: "minimumTractionPreRevenue", value: false },
      { name: "minimumTractionPostRevenue", value: false },
    ]);
    const advancedAssuranceOptions = reactive([
      { name: "advanceAssuranceSeis", value: false },
      { name: "advanceAssuranceEis", value: false },
      { name: "advanceAssuranceAppliedFor", value: false },
      { name: "advanceAssuranceNotApplicable", value: false },
    ]);
    const business = inject("business");
    watch(() => props.formDataTemp, (value) => {
      formData.value = {...value}
      syncData(value);
      advancedAssuranceOptions[0].value =
        value?.[advancedAssuranceOptions?.[0]?.name] == 1;
      advancedAssuranceOptions[1].value =
        value?.[advancedAssuranceOptions?.[1]?.name] == 1;
      advancedAssuranceOptions[2].value =
        value?.[advancedAssuranceOptions?.[2]?.name] == 1;
      advancedAssuranceOptions[3].value =
        value?.[advancedAssuranceOptions?.[3]?.name] == 1;

      stageOfEvolution[0].value = value?.[stageOfEvolution?.[0]?.name] == 1;
      stageOfEvolution[1].value = value?.[stageOfEvolution?.[1]?.name] == 1;
      stageOfEvolution[2].value = value?.[stageOfEvolution?.[2]?.name] == 1;
      stageOfEvolution[3].value = value?.[stageOfEvolution?.[3]?.name] == 1;

      minimumTraction[0].value = value?.[minimumTraction?.[0]?.name] == 1;
      minimumTraction[1].value = value?.[minimumTraction?.[1]?.name] == 1;
      minimumTraction[2].value = value?.[minimumTraction?.[2]?.name] == 1;
      minimumTraction[3].value = value?.[minimumTraction?.[3]?.name] == 1;
      if (
        value?.[advancedAssuranceOptions?.[0]?.name] == 0 &&
        value?.[advancedAssuranceOptions?.[1]?.name] == 0 &&
        value?.[advancedAssuranceOptions?.[2]?.name] == 0 &&
        value?.[advancedAssuranceOptions?.[3]?.name] == 0
      )
        isAnyAdvancedAssuranceNotSelected.value = false;
      else isAnyAdvancedAssuranceNotSelected.value = true;
      shouldShowError();
    });
    const syncData = (value) => {
      if (value.advanceAssuranceSeis) advancedAssuranceOptions[0].value = true;
      if (value.advanceAssuranceEis) advancedAssuranceOptions[1].value = true;
      if (value.advanceAssuranceAppliedFor)
        advancedAssuranceOptions[2].value = true;
      if (value.advanceAssuranceNotApplicable)
        advancedAssuranceOptions[3].value = true;
      for (let i = 0; i < advancedAssuranceOptions.length; i++) {
        if (!eval(formData.value[advancedAssuranceOptions[i].name] as string))
          formData.value[advancedAssuranceOptions[i].name] = "0";
      }

      if (value.stageOfEvolutionPreSeed) stageOfEvolution[0].value = true;
      if (value.stageOfEvolutionSeed) stageOfEvolution[1].value = true;
      if (value.stageOfEvolutionPreSeriesA) stageOfEvolution[2].value = true;
      if (value.stageOfEvolutionSeriesA) stageOfEvolution[3].value = true;
      for (let i = 0; i < stageOfEvolution.length; i++) {
        if (!eval(formData.value[stageOfEvolution[i].name] as string))
          formData.value[stageOfEvolution[i].name] = "0";
      }

      if (value.minimumTractionPreMvp) minimumTraction[0].value = true;
      if (value.minimumTractionPostMvp) minimumTraction[1].value = true;
      if (value.minimumTractionPreRevenue) minimumTraction[2].value = true;
      if (value.minimumTractionPostRevenue) minimumTraction[3].value = true;
      for (let i = 0; i < minimumTraction.length; i++) {
        if (!eval(formData.value[minimumTraction[i].name] as string))
          formData.value[minimumTraction[i].name] = "0";
      }
    };
    watch(
      () => props.formDataTemp,
      () => {
        formData.value = props.formDataTemp;
      }
    );
    const fieldChanged = (event) => {
      setTimeout(() => {
        shouldShowError();
      }, 1);
      formData.value[event.target.name] = event.target.checked ? "1" : "0";
      emit("form-data", formData.value);
    };
    const enums = reactive({
      advanceAssuranceSeis: "SEIS",
      advanceAssuranceEis: "EIS",
      advanceAssuranceAppliedFor: "Applied For",
      advanceAssuranceNotApplicable: "Not Applicable",
      stageOfEvolutionPreSeed: "Pre-seed",
      stageOfEvolutionSeed: "Seed",
      stageOfEvolutionPreSeriesA: "Pre-series A",
      stageOfEvolutionSeriesA: "Series A",
      minimumTractionPreMvp: "Pre-MVP",
      minimumTractionPostMvp: "Post-MVP",
      minimumTractionPreRevenue: "Pre-Revenue",
      minimumTractionPostRevenue: "Post-Revenue",
    });
    return {
      stageOfEvolution,
      minimumTraction,
      isAnyAdvancedAssuranceNotSelected,
      formData,
      fieldChanged,
      advancedAssuranceOptions,
      enums,
      touched,
      shouldShowError,
    };
  },
});
